export default __webpack_public_path__ + "static/media/service.3418ea70.svg";